import React from 'react';
import { RawPortableText } from '../types';
import BlockContent from '@sanity/block-content-to-react';
import ResourcesPageLayout from '../components/ResourcesPageLayout';
import SEO from '../components/SEO';
import serializers from '../serializers';

import * as styles from './ResourceArticleSectionPage.module.scss';

interface ResourceArticleSectionPageProps {
  pageContext: {
    title: string;
    slug: {
      current: string;
    };
    _rawBody: RawPortableText;
  };
}

const ResourceArticleSectionPage = ({
  pageContext: resourceArticleSection,
}: ResourceArticleSectionPageProps): React.ReactElement => {
  return (
    <ResourcesPageLayout currentSlug={resourceArticleSection.slug.current} withPageContentBox>
      <SEO
        title={resourceArticleSection.title}
        urlPath={'/resources/' + resourceArticleSection.slug.current}
      />
      <div className={styles.container}>
        <h2>{resourceArticleSection.title}</h2>
        <div className={styles.body}>
          <BlockContent blocks={resourceArticleSection._rawBody} serializers={serializers} />
        </div>
      </div>
    </ResourcesPageLayout>
  );
};

export default ResourceArticleSectionPage;
